import { env } from "@/env/server"
import { getAbsoluteUrl } from "@/utils/url"

const name = `BacklinkGPT`
const nameWithEnv = env.NEXT_PUBLIC_PREVIEW_MODE
  ? `${name} (Preview)`
  : env.NEXT_PUBLIC_DEVELOPMENT_MODE
    ? `${name} (Development)`
    : name

export const siteConfig = {
  name,
  nameWithEnv,

  organization: "backlinkgpt.com",
  organizationUrl: "https://backlinkgpt.com",

  url: getAbsoluteUrl(),
  appUrl: getAbsoluteUrl("/app"),

  ogLogo: getAbsoluteUrl("/og/logo.png"),
  ogBanner: getAbsoluteUrl("/og/banner.jpg"),

  title: `${nameWithEnv} – AI-powered link building.`,
  titleTemplate: `%s | ${nameWithEnv}`,
} as const

export type TSiteConfig = typeof siteConfig
